let date = new Date();
date.setHours(date.getHours() + 1);
const date_plus_1 = Math.floor( date.getTime());
date.setHours(date.getHours() - 2);
const date_minus_1 = Math.floor( date.getTime());
date.setHours(date.getHours() - 1);
const date_minus_2 = Math.floor( date.getTime());
date.setHours(date.getHours() - 1);
const date_minus_3 = Math.floor( date.getTime());

export const nextHof = date_plus_1;
export const hofData = [
  {
    name: "Felix",
    time: 15161,
    timestamp: date_minus_1,
    image: "https://avatars.io/twitter/dev_ze/small",
    link: "https://twitter.com/dev_ze"
  },
  {
    name: "Felix2",
    time: 12343,
    timestamp: date_minus_2,
    image: "https://github.com/felixbutzbach.png?size=40",
    link: "https://github.com/felixbutzbach"
  },
  {
    name: "Felix3",
    time: 13343,
    timestamp: date_minus_3,
    image: "https://s2.googleusercontent.com/s2/favicons?domain=http://bucketman-game.com/",
    link: "http://bucketman-game.com/"
  },
  {
    name: "Felix",
    time: 1234,
    timestamp: date_minus_3,
  },
  {
    name: "Felix2",
    time: 12343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix3",
    time: 13343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix",
    time: 1234,
    timestamp: date_minus_3,
  },
  {
    name: "Felix2",
    time: 12343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix3",
    time: 13343,
    timestamp: date_minus_3,
  },
  {
    name: "Joach",
    time: 1234,
    timestamp: date_minus_3,
  },
  {
    name: "Bot15",
    time: 12343,
    timestamp: date_minus_3,
  },
  {
    name: "Bot3",
    time: 13343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix",
    time: 15161,
    timestamp: date_minus_3,
  },
  {
    name: "Felix2",
    time: 12343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix3",
    time: 13343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix",
    time: 1234,
    timestamp: date_minus_3,
  },
  {
    name: "Felix2",
    time: 12343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix3",
    time: 13343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix",
    time: 1234,
    timestamp: date_minus_3,
  },
  {
    name: "Felix2",
    time: 12343,
    timestamp: date_minus_3,
  },
  {
    name: "Felix3",
    time: 13343,
    timestamp: date_minus_3,
  },
  {
    name: "Joach",
    time: 1234,
    timestamp: date_minus_3,
  },
  {
    name: "Bot15",
    time: 12343,
    timestamp: date_minus_3,
  },
  {
    name: "Bot3",
    time: 13343,
    timestamp: date_minus_3,
  }
]